<template>
  <div class="customerService" id="drag">
      <div class="main_cons"  @mouseleave="handlerLeave" @mousemove="handlerMove" @mousedown="mousedown" @mouseup="mouseup">
          <img src="http://img-dbzd.doubaozhidao.com/20220815/TSwwPbTipm6e3xZYcpniFD5cYWn43N761660554235261.png?x-oss-process=image/quality,q_80/format,png" alt="">
      </div>
      <div :class="showRight?'QR_code':'QR_code_left'" v-show="isShowCustomer">
              <img src="http://img-dbzd.doubaozhidao.com/20220815/t3Gxirr2KWjBtyKrCtJKxfxMabtPiYth1660554235275.png?x-oss-process=image/quality,q_80/format,png" alt="">
              <img class="inviteCode" :src="'http://img-dbzd.doubaozhidao.com/invite/invite5.png?times='+ Date.now()" alt="">
          </div>
      
  </div>
</template>

<script>
export default {
    name: 'customer',
    data(){
        return{
            isShowCustomer:false,
            dom: null,
            innerHeight: 0,
            innerWidth: 0,
            offsetHeight: 0,
            offsetWidth: 0,
            startX: 0,
            startY: 0,
            endX: 0,
            endY: 0,
            diffX: 0,
            diffY: 0,
            isDrag: false,
            showRight:true
        }
    },
    mounted(){
      this.dragFunc();
    },
    methods:{
        dragFunc(){
            this.dom = document.getElementById('drag');
            this.innerHeight= document.documentElement.clientHeight;
            this.innerWidth= document.documentElement.clientWidth;
            this.offsetHeight= this.dom.offsetHeight;
            this.offsetWidth=  this.dom.offsetWidth;
        },
        mousedown(e){
            console.log('按下')
            this.isDrag= true;
            let et= e || window.event;
            this.startX= this.startY= et.clientX;
            this.endX= this.endY= et.clientY;
            this.diffY= et.clientY - this.dom.offsetTop;
            this.diffX= et.clientX - this.dom.offsetLeft;
            et.preventDefault();
            console.log(this.startX,this.endX,this.diffY,this.diffX)
        },
        handlerMove(e){ 
           if(this.isDrag){
                let et= e || window.event;
                let currentX= et.clientX;
                let currentY= et.clientY;
                let my = currentY - this.diffY;
                let mx = currentX - this.diffX;
                let top,left;
                if(mx < 0){
                    left= 0;
                }else if(mx > this.innerWidth - this.offsetWidth){
                    left= this.innerWidth - this.offsetWidth;
                }else{
                    left= mx;
                }
                if(my < 0){
                    top= 0;
                }else if(my > this.innerHeight - this.offsetHeight){
                    top= this.innerHeight - this.offsetHeight;
                }else{
                    top= my;
                }
                console.log(top,'top',left,'left')
                this.dom.style.top= `${top}px`;
                this.dom.style.left= `${left>50?left:55}px`;
                if(left>=0&&left<220){
                    this.showRight = false
                }else{
                    this.showRight = true
                }
            }else{
                this.isShowCustomer = true
            }
        },
        handlerLeave(){
            this.isShowCustomer = false
            this.isDrag= false;
        },
        mouseup(e){
            console.log('抬起')
            this.isDrag= false;
            this.isShowCustomer = false
        },
    }

}
</script>

<style lang="less">
    .customerService{
        width: 70px;
        height: 70px;
        position: fixed;
        top: 50%;
        right: 0;
        transform: translateX(-50%);
        z-index: 99999;
        display: flex;
        align-items: center;
        .main_cons{
            img{
                width: 70px;
                height: 70px;
            }
        }
        .QR_code,.QR_code_left{
            width: 130px;
            height: 156px;
            position: relative;
            right: 200px;
            z-index: 99999;
            img{
                vertical-align: middle;
            }
            .inviteCode{
                position: absolute;
                top: 40px;
                left: 11px;
                width: 106px;
                height: 106px;
                z-index: 9999999;
            }
        }
       .QR_code_left{
            left: 20px;
       }
    }
</style>